/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  BoxComponentStyled,
  Wrapper,
} from "./styled";
import FormFactory from "../form-factory";
import { GroupProp } from "../form-factory/utils/util";

type ComponentProps = {
  children?: any;
  handleFilter: any;
  searchLabel?: string;
  placehoderSearch?: string;
};

const FilterBar = ({
  searchLabel,
  children,
  handleFilter,
  placehoderSearch,
}: ComponentProps): JSX.Element => {
  const [open, setOpenDropDown] = useState<boolean>(false);
  const [close, setClose] = useState<boolean>(false);
  const debounceRef = React.useRef<NodeJS.Timeout | null>(null);

  const closeDropdown = (): void => {
    if (open) {
      setOpenDropDown(false);
    }
  };
  useEffect(() => {
    if (close) {
      closeDropdown();
      setClose(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [close, handleFilter]);


  const fields: GroupProp[] = [{
    groupName: "FILTER",
    groupLabel: "",
    items: [
      {
        type: "text",
        name: "query",
        label: searchLabel || "Pesquisar",
        placeholder: placehoderSearch || "Digite aqui...",
        onChange: (value: string) => {
          if (debounceRef.current) {
            clearTimeout(debounceRef.current);
          }
          debounceRef.current = setTimeout(() => {
            handleFilter((prev: any) => ({
              ...prev,
              query: value || "",
            }));
          }, 500);
        },
        col: {
          xs: 12,
          md: 12,
          lg: 12,
        },
      },
    ]
  }];

  return (
    <Wrapper>
      <BoxComponentStyled>
        <FormFactory
          groups={fields}
          onSubmit={() => {
            console.log("submit form");
          }}
          backButton={{
            submit: "Voltar",
            submitting: "Voltando...",
            hide: true,
          }}
          button={{
            submit: "Salvar",
            submitting: "Salvando...",
            hide: true,
          }}

        />
      </BoxComponentStyled>
      {children}
    </Wrapper>
  );
};
export default FilterBar;
